import p1 from "@/assets/p1.jpg";
import p2 from "@/assets/p2.jpg";
import p3 from "@/assets/p3.jpg";
import p4 from "@/assets/p4.jpg";
import w1 from "@/assets/w1.jpg";
import w2 from "@/assets/w2.jpg";
import w3 from "@/assets/w3.jpg";
import w4 from "@/assets/w4.jpg";
import w5 from "@/assets/w5.jpg";
import w6 from "@/assets/w6.jpg";
import potd from "@/assets/photo-of-the-day.jpg";
import cover from "@/assets/cover.jpg";

export const heroImage = cover;
export const photoOfTheDayImage = potd;

export type Theme =
  | "portraits"
  | "wedding"
  | "product"
  | "family"
  | "event"
  | "business"
  | "fashion"
  | "editorial"
  | "real-estate"
  | "sport"
  | "boudoir"
  | "street"
  | "open";

export const themes: { id: Theme; label: string; description: string }[] = [
  { id: "portraits", label: "Portraits", description: "Editorial- und Persönlichkeits-Portraits, Gesichter, Charakter, Stille." },
  { id: "wedding", label: "Hochzeit", description: "Dokumentarische Hochzeitsfotografie, ruhige, ehrliche Momente." },
  { id: "family", label: "Familie", description: "Familienfotografie, unaufgeregte Momente zwischen Eltern, Kindern und Generationen." },
  { id: "event", label: "Event", description: "Event- und Veranstaltungsfotografie, Konferenzen, Galas, private Feiern." },
  { id: "business", label: "Business", description: "Corporate, Headshots und Branding, Menschen und Räume von Unternehmen." },
  { id: "fashion", label: "Fashion", description: "Mode- und Editorial-Fotografie, Looks, Kampagnen, Lookbooks." },
  { id: "editorial", label: "Editorial", description: "Redaktionelle Strecken und Magazin-Arbeiten, Geschichten in Bildern." },
  { id: "product", label: "Produkt", description: "Produkt- und Still-Life-Fotografie, Form, Material und Licht für Marken." },
  { id: "real-estate", label: "Immobilien & Architektur", description: "Interior, Architektur und Real Estate, Räume, Linien, Licht." },
  { id: "sport", label: "Sport", description: "Sport- und Action-Fotografie, Wettkampf, Bewegung, Energie." },
  { id: "boudoir", label: "Boudoir", description: "Intim- und Boudoir-Fotografie, Selbstbewusstsein und Ästhetik." },
  { id: "street", label: "Streetphotography", description: "Street- und Reportagefotografie, Beobachtungen aus dem urbanen Alltag." },
  { id: "open", label: "Open", description: "Freie Arbeiten, Reportage, Street und alles dazwischen." },
];

export type Photographer = {
  id: string;
  name: string;
  region: string;
  themes: Theme[];
  priceFrom: number;
  priceTo: number;
  equipment: string[];
  bio: string;
  shoots: string;
  email: string;
  portrait: string;
  gallery: string[];
  galleryThemes?: Theme[];
  galleryThemesAll?: Theme[][];
  galleryTitles?: string[];
  galleryCaptions?: string[];
  country?: string | null;
  city?: string | null;
  websiteUrl?: string | null;
  instagramHandle?: string | null;
  portraitPosition?: string | null;
  portraitZoom?: number | null;
  shootingSettings?: string[];
  languages?: string[];
  foundingMember?: boolean;
  tfp?: boolean;
  priceOnRequest?: boolean;
};

export const photographers: Photographer[] = [
  {
    id: "lina-kessler",
    name: "Lina Keßler",
    region: "Berlin",
    themes: ["portraits", "open"],
    priceFrom: 450,
    priceTo: 1800,
    equipment: ["Leica Q3", "Mamiya 7", "Profoto B10"],
    bio: "Ich fotografiere Menschen am liebsten dort, wo sie aufhören sich zu beobachten. Studierte an der Ostkreuzschule, lebt zwischen Berlin und Lissabon.",
    shoots: "Berlin, Brandenburg, auf Anfrage europaweit.",
    email: "lina@om-selected.studio",
    portrait: p1,
    gallery: [w5, w1, w3, w6, p1, w4],
  },
  {
    id: "matthias-rauch",
    name: "Matthias Rauch",
    region: "Hamburg",
    themes: ["wedding", "portraits"],
    priceFrom: 1200,
    priceTo: 4500,
    equipment: ["Sony A7R V", "Hasselblad 500C", "natürliches Licht"],
    bio: "Dokumentarisch, ruhig, beobachtend. Hochzeiten als Reportage, keine gestellten Bilder, kein Pathos.",
    shoots: "Hamburg, Nordsee, Skandinavien.",
    email: "matthias@om-selected.studio",
    portrait: p2,
    gallery: [w1, w3, w6, w5, p2, w4],
  },
  {
    id: "anna-volkov",
    name: "Anna Volkov",
    region: "München",
    themes: ["portraits", "open"],
    priceFrom: 600,
    priceTo: 2400,
    equipment: ["Phase One XT", "Broncolor Siros"],
    bio: "Fashion- und Editorial-Portraits mit klarer Bildsprache. Veröffentlicht in Numéro, Zeit Magazin, Vogue Adria.",
    shoots: "München, Wien, Mailand.",
    email: "anna@om-selected.studio",
    portrait: p3,
    gallery: [w5, p3, w1, w6, w3, w4],
  },
  {
    id: "jonas-feld",
    name: "Jonas Feld",
    region: "Köln",
    themes: ["product", "open"],
    priceFrom: 800,
    priceTo: 3200,
    equipment: ["Fuji GFX 100 II", "Kino Flo", "Tilt-Shift Optiken"],
    bio: "Stilles Produktdesign-Still-Life. Uhren, Möbel, Spirituosen. Arbeit für unabhängige Marken aus DACH.",
    shoots: "Köln, Düsseldorf, Studio in Antwerpen.",
    email: "jonas@om-selected.studio",
    portrait: p4,
    gallery: [w2, w4, p4, w6, w5, w3],
  },
];

export const selectedWorks = [
  { id: "s1", image: w5, photographerId: "anna-volkov", caption: "Untitled, Atelier No. 3", theme: "portraits" as Theme },
  { id: "s2", image: w1, photographerId: "matthias-rauch", caption: "Norderney, August", theme: "wedding" as Theme },
  { id: "s3", image: w2, photographerId: "jonas-feld", caption: "Object Study II", theme: "product" as Theme },
  { id: "s4", image: w3, photographerId: "lina-kessler", caption: "Lissabon, Alfama", theme: "open" as Theme },
  { id: "s5", image: w6, photographerId: "lina-kessler", caption: "Schwarzwald, Dawn", theme: "open" as Theme },
  { id: "s6", image: w4, photographerId: "jonas-feld", caption: "Concrete, Series 04", theme: "open" as Theme },
];

export const regions = Array.from(new Set(photographers.map((p) => p.region))).sort();

export const countries = [
  "Deutschland", "Österreich", "Schweiz",
  "Belgien", "Bulgarien", "Dänemark", "Estland", "Finnland", "Frankreich",
  "Griechenland", "Irland", "Island", "Italien", "Kroatien", "Lettland",
  "Liechtenstein", "Litauen", "Luxemburg", "Malta", "Niederlande", "Norwegen",
  "Polen", "Portugal", "Rumänien", "Schweden", "Serbien", "Slowakei",
  "Slowenien", "Spanien", "Tschechien", "Ukraine", "Ungarn",
  "Vereinigtes Königreich", "Zypern",
] as const;
export type Country = (typeof countries)[number];

export const citiesByCountry: Record<Country, string[]> = {
  Deutschland: [
    "Berlin", "Hamburg", "München", "Köln", "Frankfurt", "Stuttgart",
    "Düsseldorf", "Leipzig", "Dresden", "Hannover", "Nürnberg", "Bremen",
    "Dortmund", "Essen", "Duisburg", "Bochum", "Wuppertal", "Bonn",
    "Münster", "Karlsruhe", "Mannheim", "Augsburg", "Wiesbaden", "Mainz",
    "Freiburg", "Heidelberg", "Regensburg", "Aachen", "Kiel", "Lübeck",
    "Erfurt", "Rostock", "Magdeburg", "Saarbrücken", "Potsdam", "Ulm",
    "Würzburg", "Braunschweig", "Bielefeld", "Halle", "Chemnitz", "Kassel",
    "Oldenburg", "Osnabrück", "Ingolstadt", "Darmstadt", "Heilbronn", "Trier",
  ],
  Österreich: [
    "Wien", "Graz", "Linz", "Salzburg", "Innsbruck", "Klagenfurt",
    "Villach", "Wels", "Sankt Pölten", "Dornbirn", "Bregenz", "Eisenstadt",
    "Steyr", "Wiener Neustadt", "Krems", "Leoben", "Baden",
  ],
  Schweiz: [
    "Zürich", "Bern", "Basel", "Genf", "Lausanne", "Luzern", "St. Gallen",
    "Winterthur", "Lugano", "Biel", "Thun", "Köniz", "La Chaux-de-Fonds",
    "Schaffhausen", "Fribourg", "Chur", "Neuchâtel", "Sion", "Zug",
    "Uster", "Locarno", "Davos",
  ],
  Belgien: [
    "Brüssel", "Antwerpen", "Gent", "Charleroi", "Lüttich", "Brügge",
    "Namur", "Löwen", "Mons", "Aalst",
  ],
  Bulgarien: [
    "Sofia", "Plowdiw", "Warna", "Burgas", "Russe", "Stara Sagora",
    "Plewen", "Sliwen",
  ],
  Dänemark: [
    "Kopenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg", "Randers",
    "Kolding", "Horsens",
  ],
  Estland: ["Tallinn", "Tartu", "Narva", "Pärnu", "Kohtla-Järve"],
  Finnland: [
    "Helsinki", "Espoo", "Tampere", "Vantaa", "Oulu", "Turku",
    "Jyväskylä", "Lahti",
  ],
  Frankreich: [
    "Paris", "Marseille", "Lyon", "Toulouse", "Nizza", "Nantes",
    "Montpellier", "Straßburg", "Bordeaux", "Lille", "Rennes", "Reims",
    "Le Havre", "Toulon", "Grenoble", "Dijon", "Cannes",
  ],
  Griechenland: [
    "Athen", "Thessaloniki", "Patras", "Heraklion", "Larisa", "Volos",
    "Rhodos", "Chania",
  ],
  Irland: ["Dublin", "Cork", "Limerick", "Galway", "Waterford", "Drogheda"],
  Island: ["Reykjavík", "Kópavogur", "Hafnarfjörður", "Akureyri"],
  Italien: [
    "Rom", "Mailand", "Neapel", "Turin", "Palermo", "Genua", "Bologna",
    "Florenz", "Bari", "Catania", "Venedig", "Verona", "Triest", "Padua",
  ],
  Kroatien: [
    "Zagreb", "Split", "Rijeka", "Osijek", "Zadar", "Dubrovnik", "Pula",
  ],
  Lettland: ["Riga", "Daugavpils", "Liepāja", "Jelgava", "Jūrmala"],
  Liechtenstein: ["Vaduz", "Schaan", "Triesen", "Balzers"],
  Litauen: ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai", "Panevėžys"],
  Luxemburg: ["Luxemburg", "Esch-sur-Alzette", "Differdingen", "Düdelingen"],
  Malta: ["Valletta", "Birkirkara", "Sliema", "St. Julian's", "Mosta"],
  Niederlande: [
    "Amsterdam", "Rotterdam", "Den Haag", "Utrecht", "Eindhoven",
    "Groningen", "Tilburg", "Almere", "Breda", "Nijmegen", "Haarlem",
  ],
  Norwegen: [
    "Oslo", "Bergen", "Trondheim", "Stavanger", "Drammen", "Tromsø",
    "Kristiansand",
  ],
  Polen: [
    "Warschau", "Krakau", "Łódź", "Breslau", "Posen", "Danzig",
    "Stettin", "Bydgoszcz", "Lublin", "Kattowitz",
  ],
  Portugal: [
    "Lissabon", "Porto", "Amadora", "Braga", "Coimbra", "Funchal",
    "Faro", "Aveiro",
  ],
  Rumänien: [
    "Bukarest", "Cluj-Napoca", "Timișoara", "Iași", "Constanța",
    "Craiova", "Brașov", "Sibiu",
  ],
  Schweden: [
    "Stockholm", "Göteborg", "Malmö", "Uppsala", "Västerås", "Örebro",
    "Linköping", "Helsingborg", "Lund",
  ],
  Serbien: ["Belgrad", "Novi Sad", "Niš", "Kragujevac", "Subotica"],
  Slowakei: ["Bratislava", "Košice", "Prešov", "Žilina", "Nitra", "Banská Bystrica"],
  Slowenien: ["Ljubljana", "Maribor", "Celje", "Kranj", "Koper"],
  Spanien: [
    "Madrid", "Barcelona", "Valencia", "Sevilla", "Saragossa", "Málaga",
    "Murcia", "Palma", "Bilbao", "Alicante", "Córdoba", "Granada",
    "San Sebastián", "Marbella",
  ],
  Tschechien: [
    "Prag", "Brünn", "Ostrava", "Pilsen", "Liberec", "Olomouc",
    "Budweis", "Karlsbad",
  ],
  Ukraine: [
    "Kiew", "Charkiw", "Odessa", "Dnipro", "Lwiw", "Saporischschja",
  ],
  Ungarn: [
    "Budapest", "Debrecen", "Szeged", "Miskolc", "Pécs", "Győr",
    "Nyíregyháza",
  ],
  "Vereinigtes Königreich": [
    "London", "Manchester", "Birmingham", "Glasgow", "Liverpool", "Leeds",
    "Edinburgh", "Bristol", "Cardiff", "Belfast", "Sheffield", "Brighton",
  ],
  Zypern: ["Nikosia", "Limassol", "Larnaka", "Paphos"],
};

export const priceBuckets = [
  { id: "lt500", label: "bis 500 €", min: 0, max: 499 },
  { id: "500-1500", label: "500, 1.500 €", min: 500, max: 1500 },
  { id: "1500-3000", label: "1.500, 3.000 €", min: 1500, max: 3000 },
  { id: "gt3000", label: "ab 3.000 €", min: 3000, max: Number.MAX_SAFE_INTEGER },
] as const;
export type PriceBucketId = (typeof priceBuckets)[number]["id"];